import { Component, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { Drawer, DrawerRef } from '../../../drawer.service';

/**
 * @ignore
 */
@Component({
  selector: 'uex-drawer-content',
  templateUrl: './content.component.html',
  host: {
    class: 'uex-drawer-body modal-body',
    '[class.has-header]': 'has_header',
    '[class.has-footer]': 'has_footer',
  }
})
export class DrawerContentComponent implements AfterViewInit, OnDestroy {

  constructor(
    public elementRef: ElementRef,
    private _drawerRef: DrawerRef
  ) {
    this._drawer = this._drawerRef.drawer;
  }

  private _drawer: Drawer;

  public has_header: boolean;
  public has_footer: boolean;

  private _header_list_subscription: Subscription;
  private _footer_list_subscription: Subscription;

  public ngAfterViewInit() {
    setTimeout(() => {
      this._setHasHeader();
      this._setHasFooter();
      this._header_list_subscription = this._drawer.$onHeaderListChange.subscribe(() => this._setHasHeader());
      this._footer_list_subscription = this._drawer.$onFooterListChange.subscribe(() => this._setHasFooter());
    }, 100);
  }

  public ngOnDestroy() {
    if (this._header_list_subscription) { this._header_list_subscription.unsubscribe(); }
    if (this._footer_list_subscription) { this._footer_list_subscription.unsubscribe(); }
  }

  public get offsetTop(): number {
    return this.elementRef.nativeElement.offsetTop;
  }

  public scrollTo(offset: number) {
    if (this._drawer.getOffsetHeight() > 0) { this.elementRef.nativeElement.scrollTop = offset; }
  }

  public scrollToTop() {
    if (this._drawer.getOffsetHeight() > 0) { this.elementRef.nativeElement.scrollTop = 0; }
  }

  public scrollToBottom() {
    if (this._drawer.getOffsetHeight() > 0) { this.elementRef.nativeElement.scrollTop = this.elementRef.nativeElement.scrollHeight; }
  }

  private _setHasHeader() {
    this.has_header = this._drawer.hasHeader();
  }

  private _setHasFooter() {
    this.has_header = this._drawer.hasHeader();
  }
}
